module.exports = __webpack_public_path__ + "img/assertiveness_talkAboutIt.448b063f.png";